import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Menu, Social } from '../constant'
import ImgLogo from '../assets/img/iconWhite.png'

const NavBar = () => {
    const [activeLink, setActiveLink] = React.useState('home');
    const [scrolled, setScrolled] = React.useState(false)

    React.useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50 && !scrolled) {
                setScrolled(true)
            } else if (window.scrollY < 50 && scrolled) {
                setScrolled(false)
            }
        }

        window.addEventListener('scroll', onScroll)

        return () => window.removeEventListener('scroll', onScroll)
    })

    const onUpdateActive = (value) => {
        setActiveLink(value)
    }

    const activate = (path) => {
        return activeLink === path ? 'active navbar-link' : 'navbar-link'
    }

    return (
        <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
            <Container>
                <Navbar.Brand href="#home">
                    <img src={ImgLogo} alt="logo" />
                    <span className='fw-bold text-white'>rlando</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto text-center text-lg-auto">
                        {
                            Menu.map((v, k) => {
                                return <Nav.Link href={v.href} key={k} className={activate(v.label)} onClick={() => onUpdateActive(v.label)}>{v.label}</Nav.Link>
                            })
                        }
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            {Social.map((v, k) => <a href={v.link} key={k} target="__blank"><img src={v.icon} alt={v.id} /></a>)}
                        </div>
                        <a href="#connect" className="btn__contact"><span>Discutons !</span></a>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}
export default NavBar;